import type { ReactNode } from 'react';

import { Loading } from '../../styles';

interface IIconWithLoadingStateProps {
  dataCy?: string;
  icon: ReactNode;
  loading: boolean;
  size?: number;
}
export const IconWithLoadingState = ({
  dataCy = 'loading-sidebar-select',
  icon,
  loading,
  size = 24,
}: IIconWithLoadingStateProps): ReactNode => {
  // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
  if (!icon) return null;

  return loading ? (
    <Loading $height={size} $width={size} dataCy={dataCy} />
  ) : (
    icon
  );
};
